import type { DocumentTreeItem } from "@exopengithub/exokit";
import type { DomainDocumentItem } from "../api/types";
import {
	buildDocumentTree,
	type DocumentTreeNode,
	findReportsRoot,
} from "./reportsFolders";

export type ReportTree = {
	items: DocumentTreeItem[];
	/** The Reports → Documents folder; `null` when the domain has none. */
	rootId: string | null;
};

const toTreeItem = (item: DomainDocumentItem): DocumentTreeItem => ({
	id: String(item.id),
	parentId: item.parentId == null ? null : String(item.parentId),
	name: item.name,
	type: item.type,
	bytes: item.bytes ?? undefined,
});

/** The documents as `DocumentTree` items, rooted at the report tree. */
export function toReportTree(documents: DomainDocumentItem[]): ReportTree {
	const root = findReportsRoot(buildDocumentTree(documents));
	if (!root) return { items: [], rootId: null };
	return {
		items: documents.map(toTreeItem),
		rootId: String(root.item.id),
	};
}

const collectFiles = (node: DocumentTreeNode): DomainDocumentItem[] =>
	node.item.type === "file" ? [node.item] : node.children.flatMap(collectFiles);

/** The files the report tree shows, depth-first in list order — what the picker would let the caller open. */
export function listReportFiles(
	documents: DomainDocumentItem[],
): DomainDocumentItem[] {
	const root = findReportsRoot(buildDocumentTree(documents));
	return root ? root.children.flatMap(collectFiles) : [];
}
